import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
let timer;
let timer2;
interface HouseLetterPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
}
@inject('app', 'site', 'user', 'thread')
@observer
class HouseLetterPCPage extends BasePage<HouseLetterPCPageProps> {
    componentDidMount() {
        super.componentDidMount();
        this.props.history.push(`/downloadAppEnter`);
    }


    render() {
        return ( <div className={styles.wrapper}>
            
        </div>)
    }
}

export default withRouter(HouseLetterPCPage);
